import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {LeftoverConstrainModel} from "../../models/leftover-constrain.model";

export class PlanningJobsFiltersPanel implements IController {

  isDraft: any;
  skills: any;
  branchIds: string[];
  depotIds: string[];
  resourceIds: any;
  selectedLeftoverConstrains?: LeftoverConstrainModel[];
  serviceAreaIds: any;
  tagNames: any;
  labels: string[];
  inRoute: any;
  isPacked: any;
  isSynced: any;
  routesData: any;
  clusterId: string;
  leftoverConstrains?: LeftoverConstrainModel[];
  onFiltersChange: Function;

  /* @ngInject */
  constructor(private $mdPanel) {
  }

  $onInit() {
  }

  ///////////////////////////////////////////////////////////
  ///////////////////  Public Functions ////////////////////
  //////////////////////////////////////////////////////////


  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_END,
        this.$mdPanel.yPosition.ALIGN_TOPS // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.planning-jobs-filters-btn')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          isDraft: this.isDraft,
          skills: this.skills || [],
          branchIds: this.branchIds || [],
          depotIds: this.depotIds || [],
          serviceAreaIds: this.serviceAreaIds || [],
          tagNames: this.tagNames || [],
          labels: this.labels || [],
          resourceIds: this.resourceIds || [],
          inRoute: this.inRoute,
          isPacked: this.isPacked,
          isSynced: this.isSynced,
          routesData: this.routesData || [],
          leftoverConstrains: this.leftoverConstrains || [],
          selectedLeftoverConstrains: this.selectedLeftoverConstrains || [],
          clusterId: this.clusterId,
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DeliveriesPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/planning/components/planning-jobs-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      skills: filterConfig.skills,
      serviceAreaIds: filterConfig.serviceAreaIds,
      tagNames: filterConfig.tagNames,
      resourceIds: filterConfig.resourceIds,
      selectedLeftoverConstrains: filterConfig.selectedLeftoverConstrains,
      inRoute: filterConfig.inRoute,
      isPacked: filterConfig.isPacked,
      isSynced: filterConfig.isSynced,
      branchIds: filterConfig.branchIds,
      depotIds: filterConfig.depotIds,
      labels: filterConfig.labels,
      resetCluster: filterConfig.resetCluster
    })
  }
}

class DeliveriesPanelCtrl implements IController {

  public isDraft: boolean;
  public filterConfig: any;
  public resourcesOptions: any;
  public filteredResourcesOptions: any;
  public resourceSearchQuery: string;
  public leftoverConstrains: LeftoverConstrainModel[];
  private siteId: string;
  private routesData: any;

  hasNoFilters: boolean = true;

  constructor(private mdPanelRef, private $q: IQService, private $mdSelect) {
    this.siteId = mdPanelRef.config.locals.data.siteId;
    this.isDraft = mdPanelRef.config.locals.data.isDraft;
    this.routesData = mdPanelRef.config.locals.data.routesData;
    this.leftoverConstrains = mdPanelRef.config.locals.data.leftoverConstrains;

    this.filterConfig = {
      skills: mdPanelRef.config.locals.data.skills,
      branchIds: mdPanelRef.config.locals.data.branchIds,
      depotIds: mdPanelRef.config.locals.data.depotIds,
      serviceAreaIds: mdPanelRef.config.locals.data.serviceAreaIds,
      tagNames: mdPanelRef.config.locals.data.tagNames,
      labels: mdPanelRef.config.locals.data.labels,
      resourceIds: mdPanelRef.config.locals.data.resourceIds,
      selectedLeftoverConstrains: mdPanelRef.config.locals.data.selectedLeftoverConstrains,
      inRoute: mdPanelRef.config.locals.data.inRoute,
      isPacked: mdPanelRef.config.locals.data.isPacked,
      isSynced: mdPanelRef.config.locals.data.isSynced,
      clusterId: mdPanelRef.config.locals.data.clusterId
    };

    if (_.get(this.filterConfig, 'resourceIds.length')) {
      this.setResourcesSelectOptions();
    }

    this.hasNoFilters = this._hasNoFilters();
  }

  $onInit() {
  }

  onChangeBranches(selectedBranchIds: string[]) {
    this.filterConfig.branchIds = selectedBranchIds;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeDepots(selectedDepotIds: string[]) {
    this.filterConfig.depotIds = selectedDepotIds;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeSkills(selectedSkills) {
    this.filterConfig.skills = selectedSkills;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeServiceAreasIds(serviceAreaIds) {
    this.filterConfig.serviceAreaIds = serviceAreaIds;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeTagNames(tagNames) {
    this.filterConfig.tagNames = tagNames;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeLabels(labels) {
    this.filterConfig.labels = labels;
    this.hasNoFilters = this._hasNoFilters();
  }

  setResourcesSelectOptions() {
    this.resourcesOptions = _.chain(this.routesData)
      .filter((r) => {
        return r.resource;
      })
      .map('resource')
      .uniqBy('id')
      .value();
    this.filteredResourcesOptions = this.resourcesOptions;
    return this.$q.when();
  }

  onResourceSearchQueryChange(query: string) {
    this.resourceSearchQuery = query;
    this.filteredResourcesOptions = !query ? this.resourcesOptions :
      this.resourcesOptions.filter(resource => _.includes(JSON.stringify(resource).toLowerCase(), query.toLowerCase()));
  }


  onChangeResourceIds(resourceIds) {
    if (resourceIds) {
      this.filterConfig.resourceIds = resourceIds;
    }
    this.hasNoFilters = this._hasNoFilters();
    this.$mdSelect.hide();
  }

  onResetCluster() {
    this.filterConfig.resetCluster = true;
  }

  onReset() {
    this.filterConfig = {
      skills: [],
      branchIds: [],
      depotIds: [],
      resourceIds: [],
      selectedLeftoverConstrains: [],
      serviceAreaIds: [],
      tagNames: [],
      labels: [],
      inRoute: undefined,
      isPacked: undefined,
      isSynced: undefined,
      resetCluster: true,
    };
    this.submit()
  }


  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.filterConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }


  cancel() {
    this.mdPanelRef.close();
  }

  private _hasNoFilters() {
    return !_.get(this.filterConfig.skills, 'length') &&
      !_.get(this.filterConfig.branchIds, 'length') &&
      !_.get(this.filterConfig.depotIds, 'length') &&
      !_.get(this.filterConfig.serviceAreaIds, 'length') &&
      !_.get(this.filterConfig.tagNames, 'length') &&
      !_.get(this.filterConfig.labels, 'length') &&
      !_.get(this.filterConfig.resourceIds, 'length') &&
      _.isUndefined(this.filterConfig.inRoute) &&
      _.isUndefined(this.filterConfig.isPacked) &&
      _.isUndefined(this.filterConfig.isSynced) &&
      !this.filterConfig.clusterId;
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningJobsFiltersPanel', {
    bindings: {
      isDraft: '<?',
      branchIds: '<',
      depotIds: '<',
      skills: '<',
      resourceIds: '<',
      selectedLeftoverConstrains: '<?',
      serviceAreaIds: '<',
      tagNames: '<',
      labels: '<',
      inRoute: '<',
      isPacked: '<',
      isSynced: '<',
      routesData: '<?',
      leftoverConstrains: '<?',
      clusterId: '<?',
      onFiltersChange: '&'
    },
    template: require('./planning-jobs-filters-panel.html').default,
    controller: PlanningJobsFiltersPanel
  });
